




















































import { Component, Vue, Prop } from 'vue-property-decorator'
import NhapLieuCtyTTChung from './NhapLieuCtyTTChung.vue'
import NhapLieuCtyTTTaiChinh from './NhapLieuCtyTTTaiChinh.vue'
import BreadCrumbs, { BreadCrumb } from '@/components/BreadCrumbs.vue'
import SectionTitle from '@/components/SectionTitle.vue'
import BaseLoading from '@/components/BaseLoading.vue'
import DialogConfirm from '@/components/DialogConfirm.vue'
import {
  getCompany,
  getFinanceInfos,
  putFinanceInfo,
  postFinanceInfo,
  deleteFinanceInfo,
  postCompanyManager,
  putCompanyManager,
  deleteCompanyManager,
  getCompanyManager
} from '@/utils/ApiServices'
import { Company, CompanyManager, FinanceInfo } from '@/utils/Interfaces'
import { handle } from '@/utils/ErrorHandling'
import BaseSnackbar from '@/components/BaseSnackbar.vue'
import { Route } from 'vue-router'
import { AxiosPromise } from 'axios'

Component.registerHooks([
  'beforeRouteUpdate',
])

@Component({
  components: {
    NhapLieuCtyTTChung,
    NhapLieuCtyTTTaiChinh,
    BreadCrumbs,
    SectionTitle,
    BaseLoading,
    BaseSnackbar,
    DialogConfirm,
  }
})
export default class NhapLieuCongTy extends Vue {
  @Prop(String) readonly slug!: string

  loading = false
  alert = false
  deletedInfoIds = []
  deletedManagerIds: Array<CompanyManager['id']> = []
  deleteConfirm = false

  company = new Company
  managers: Array<CompanyManager> = []
  financeInfos: Array<FinanceInfo> = []

  addManager () {
    // @ts-expect-error
    this.managers.push(new CompanyManager({ company: this.company.id }))
  }

  deleteManager (index: number) {
    const id = this.managers[index].id
    if (!this.deletedManagerIds.includes(id)) {
      this.deletedManagerIds.push(id)
    }
    this.managers.splice(index, 1)
  }

  async mounted () {
    await this.setCompanyAndFinanceInfo(this.slug)
    await this.setManagersInfo()
  }

  beforeRouteUpdate (...[to, , next]: [ Route, undefined, Function]) {
    this.setCompanyAndFinanceInfo(to.params.slug)
    this.setManagersInfo()
    next()
  }

  async setCompanyAndFinanceInfo (slug: Company['slug']) {
    if (this.$store.getters.hasCompanies) {
      this.company = this.$store.getters.getCompanyBySlug(slug)
    } else {
      await getCompany(slug).then(response => {
        this.company = response.data
      })
        .catch(error => {
          handle(error)
        })
    }

    getFinanceInfos(this.company.id).then(response => {
      this.financeInfos = response.data
    }).catch(error => {
      handle(error)
    })
  }

  async setManagersInfo () {
    const promises: Array<AxiosPromise> = []
    
    this.company.managers.forEach(managerId => {
      promises.push(
        getCompanyManager(managerId)
      )
    })

    await Promise.all(promises)
      .then(responses => {
        this.managers = responses.map(response => response.data)
      })
      .catch(handle)

    if (this.managers.length === 0) {
      this.addManager()  // Lúc đầu hiển thị mặc định 1 người quản lý
    }
  }

  get breadcrumbs () {
    const breadcrumbs: Array<BreadCrumb> = [
      {
        text: 'Trang chủ',
        to: { name: 'Home' },
      },
      {
        text: 'Nhập liệu',
        to: { name: 'NhapLieu' },
      },
    ]
    if (this.company !== null) {
      breadcrumbs.push({
        text: this.company.name,
        to: { name: 'NhapLieuCty', params: { slug: this.slug } },
      })
    }
    return breadcrumbs
  }

  confirmSave () {
    this.deleteConfirm = false
    this.save(true)
  }

  save (force?: boolean) {
    if (this.loading) return
    if (force === undefined) force = false

    if (this.deletedInfoIds.length > 0 && !force) {
      this.deleteConfirm = true
      return
    }

    this.loading = true

    const promises = []

    // Save company
    promises.push(
      this.saveCompany()
    )

    // Save company's managers
    for (const manager of this.managers) {
      if (manager.id === undefined) {  // id = undefined means create new
        const inputDirty = manager.name.trim() !== '' || manager.role.trim() !== ''
        if (inputDirty) {
          promises.push(
            this.createManager(manager)
          )
        }
      }
      else {
        promises.push(
          this.saveManager(manager)
        )
      }
    }

    // Save company's finance infos
    for (const financeInfo of this.financeInfos) {
      if (financeInfo.id === undefined) {  // id = undefined means create new
        promises.push(
          this.createFinanceInfo(financeInfo)
            .then(response => {
              const newInfo: FinanceInfo = response.data
              const oldInfo = this.financeInfos.find(info => info.year === newInfo.year)
              if (oldInfo !== undefined) {
                oldInfo.id = newInfo.id
              }
            })
        )
      }
      else {
        promises.push(
          this.saveFinanceInfo(financeInfo.id, financeInfo)
        )
      }
    }

    // Delete managers that the user removed
    for (const id of this.deletedManagerIds) {
      promises.push(
        this.removeManager(id)
      )
    }

    // Delete finance infos that have been removed by user
    for (const id of this.deletedInfoIds) {
      promises.push(
        this.removeFinanceInfo(id)
      )
    }

    Promise.all(promises)
      .then(() => {
        this.alert = true
      })
      .catch(error => {
        handle(error)
      })
      .finally(() => {
        this.loading = false
      })
  }

  private saveCompany () {
    return this.$store.dispatch('updateCompany', {
      slug: this.company.slug,
      company: this.company,
    })
  }

  private saveFinanceInfo (id: FinanceInfo['id'], financeInfo: FinanceInfo) {
    return putFinanceInfo(id, financeInfo)
  }

  private createFinanceInfo (financeInfo: FinanceInfo) {
    return postFinanceInfo(financeInfo)
  }

  private removeFinanceInfo (id: FinanceInfo['id']) {
    return deleteFinanceInfo(id)
  }

  private createManager (manager: CompanyManager) {
    return postCompanyManager(manager)
  }

  private saveManager (manager: CompanyManager) {
    return putCompanyManager(manager)
  }

  private removeManager (id: CompanyManager['id']) {
    return deleteCompanyManager(id)
  }
}
